<div class="home" [class.admin]="isAdmin" *ngIf="{ systemStatus: systemStatus$ | async } as isSystemEnabled">
  <div [@fadeIn]>
    <h1>{{ 'home.title' | translate }}</h1>
    <h3 *ngIf="isSystemEnabled.systemStatus">
      {{ 'home.' + (isSystemEnabled.systemStatus?.enabled ? 'systemEnabled' : 'systemDisabled') | translate }}
    </h3>
    <h2>{{ 'home.welcome' | translate }} {{ userName }}</h2>
   <ng-container *ngIf="isAdmin || (!isAdmin && isSystemEnabled.systemStatus?.enabled); else notAllowed">
          <h4>{{ 'home.optionLabel' | translate }}</h4>
  </ng-container>

  <ng-template #notAllowed>
    <h4 style="visibility: hidden;">&nbsp;</h4>
  </ng-template>
  </div>
  <div class="d-flex ctas padding-left-2rem">
    <a [@zoomFadeIn] routerLink="/preferences">
      <div>
        <span class="slds-media__figure">
          <span class="slds-icon_container slds-icon_container_circle slds-icon-standard-avatar">
            <svg class="slds-icon slds-icon_large" aria-hidden="true">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#avatar"></use>
            </svg>
          </span>
        </span>
      </div>
      <p>{{ 'home.preferencesOption' | translate }}</p>
    </a>

    <a [@zoomFadeIn] routerLink="/case" *ngIf="isSystemEnabled.systemStatus?.enabled">
      <span class="slds-media__figure">
        <span class="slds-icon_container slds-icon_container_circle slds-icon-standard-form">
          <svg class="slds-icon slds-icon_large" aria-hidden="true">
            <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#form"></use>
          </svg>
        </span>
      </span>
      <p>{{ 'home.caseEntryOption' | translate }}</p>
    </a>

    <a [@zoomFadeIn] routerLink="/admin" *ngIf="isAdmin">
      <span class="slds-media__figure">
        <span class="slds-icon_container slds-icon_container_circle slds-icon-standard-settings">
          <svg class="slds-icon slds-icon_large" aria-hidden="true">
            <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#settings"></use>
          </svg>
        </span>
      </span>
      <p>{{ 'home.adminOption' | translate }}</p>
    </a>
  </div>
  <div [@zoomFadeIn] class="cases-list d-flex ctas">
    <ups-searh-cases></ups-searh-cases>
  </div>
</div>
